<template>
	<el-dialog class="pointsPackageDialog" :visible="show" append-to-body @close="handleClose">
		<div slot="title">
			<div class="dislogTitle">
				套餐选择
			</div>
		</div>
		<div class="dislogConent">
			<div class="recharge-wrapper">
				<div class="arrow left" @click="scrollLeft">‹</div>
				<div class="scroll-container" ref="scroll">
					<div class="scroll-content">
						<div class="card" v-for="(item, index) in list" :key="index">
							<div class="title">{{ item.title }}</div>
							<div class="text">套餐内容：<span>{{ item.score }}积分</span></div>
							<div class="text">套餐金额：<span>¥ {{ item.price }}</span></div>
							<button class="btn" @click="integralOrderAdd(item)">立即充值</button>
						</div>
					</div>
				</div>
				<div class="arrow right" @click="scrollRight">›</div>
			</div>
		</div>
	</el-dialog>
</template>
<script>
	export default {
		props: {
			show: {
				type: Boolean,
				default: false
			}
		},
		data() {
			return {
				list: [],
				curGoods: {},
			}
		},
		created() {
			this.getGoodsIntegral()
		},
		methods: {
			handleClose() {
				this.$emit('close')
			},
			integralOrderAdd(item) {
				this.curGoods = item;
				this.$api.post('/OrderIntegral/integral_order_add', {
					goods_id: item.id,
				}).then(res => {
					if (res.code == 1) {
						this.$emit('orderAddSuc', res.data)
						this.handleClose()
					}
				}).catch(err => {
					console.log(err);
				})
			},
			getGoodsIntegral() {
				this.$api.post('/GoodsIntegral/integral_list', {}).then(res => {
					if (res.code == 1) {
						this.list = res.data
					}
				}).catch(err => {
					console.log(err);
				})
			},
			scrollLeft() {
				const rootFontSize = parseFloat(window.getComputedStyle(document.documentElement).fontSize);
				const thumbnailWidth = window.innerWidth <= 480 ? 4.26 * rootFontSize : 2.25 * rootFontSize;
				this.$refs.scroll.scrollBy({
					left: -thumbnailWidth,
					behavior: 'smooth'
				})
			},
			scrollRight() {
				const rootFontSize = parseFloat(window.getComputedStyle(document.documentElement).fontSize);
				const thumbnailWidth = window.innerWidth <= 480 ? 4.26 * rootFontSize : 2.25 * rootFontSize;
				this.$refs.scroll.scrollBy({
					left: thumbnailWidth,
					behavior: 'smooth'
				})
			}
		}
	}
</script>

<style lang="scss" scoped>
	@media (max-width: 480px) {
		.pointsPackageDialog {

			::v-deep .el-dialog {
				width: 10.32rem;
				border-radius: .12rem;
				background: rgba(31, 32, 39, 1);

				&__header {
					padding: .24rem .24rem;

					.dislogTitle {
						font-weight: 500;
						font-size: .36rem;
						color: rgba(255, 255, 255, .8);
					}
				}

				&__headerbtn {
					top: .24rem;
					right: .24rem;
					font-size: .32rem;
				}

				&__body {
					padding: 0 .24rem .4rem;
					display: flex;
					flex-direction: column;
					align-items: center;
				}
			}
		}

		.recharge-wrapper {
			display: flex;
			align-items: center;
			width: 9.84rem;
			margin: 0 auto;
			position: relative;
		}

		.scroll-container {
			overflow: hidden;
			width: 9.84rem;
		}

		.scroll-content {
			display: flex;
			gap: .24rem;
		}

		.card {
			display: flex;
			flex-direction: column;
			width: 4.02rem;
			min-width: 4.02rem;
			background: rgba(216, 216, 216, .1);
			border-radius: .08rem;
		}

		.title {
			margin-bottom: .48rem;
			display: flex;
			align-items: center;
			justify-content: center;
			height: .96rem;
			font-weight: 500;
			font-size: .32rem;
			color: rgba(255, 255, 255, 1);
			background: rgba(22, 115, 230, .4);
		}

		.text {
			display: flex;
			align-items: center;
			justify-content: space-between;
			padding: 0 .4rem;
			font-weight: 500;
			font-size: .28rem;
			color: rgba(185, 185, 187, 1);
			line-height: .56rem;

			span {
				color: #FFFFFF;
			}
		}

		.btn {
			margin: .6rem auto .48rem;
			display: flex;
			align-items: center;
			justify-content: center;
			width: 2.16rem;
			height: .72rem;
			padding: 0 0;
			background: rgba(22, 115, 230, 1);
			border-radius: .36rem;
			font-weight: 500;
			font-size: .24rem;
			color: #FFFFFF;
			cursor: pointer;
		}

		/* 左右箭头 */
		.arrow {
			width: .8rem;
			height: .8rem;
			line-height: .8rem;
			text-align: center;
			color: rgba(185, 185, 187, 1);
			font-weight: 700;
			font-size: .64rem;
			cursor: pointer;
			user-select: none;
		}

		.arrow.left {
			margin-right: .2rem;
		}

		.arrow.right {
			margin-left: .2rem;
		}
	}

	@media (min-width: 481px) {
		.pointsPackageDialog {

			::v-deep .el-dialog {
				width: 10.32rem;
				border-radius: .12rem;
				background: rgba(31, 32, 39, 1);

				&__header {
					padding: .24rem .24rem;

					.dislogTitle {
						font-weight: 500;
						font-size: .18rem;
						color: rgba(255, 255, 255, .8);
					}
				}

				&__headerbtn {
					top: .24rem;
					right: .24rem;
					font-size: .16rem;
				}

				&__body {
					padding: 0 .24rem .4rem;
					display: flex;
					flex-direction: column;
					align-items: center;
				}
			}
		}

		.recharge-wrapper {
			display: flex;
			align-items: center;
			width: 9.84rem;
			margin: 0 auto;
			position: relative;
		}

		.scroll-container {
			overflow: hidden;
			width: 9.84rem;
		}

		.scroll-content {
			display: flex;
			gap: .24rem;
		}

		.card {
			display: flex;
			flex-direction: column;
			width: 2.01rem;
			min-width: 2.01rem;
			background: rgba(216, 216, 216, .1);
			border-radius: .08rem;
		}

		.title {
			margin-bottom: .24rem;
			display: flex;
			align-items: center;
			justify-content: center;
			height: .48rem;
			font-weight: 500;
			font-size: .16rem;
			color: rgba(255, 255, 255, 1);
			background: rgba(22, 115, 230, .4);
		}

		.text {
			display: flex;
			align-items: center;
			justify-content: space-between;
			padding: 0 .2rem;
			font-weight: 500;
			font-size: .14rem;
			color: rgba(185, 185, 187, 1);
			line-height: .28rem;

			span {
				color: #FFFFFF;
			}
		}

		.btn {
			margin: .3rem auto .24rem;
			display: flex;
			align-items: center;
			justify-content: center;
			width: 1.08rem;
			height: .36rem;
			padding: 0 0;
			background: rgba(22, 115, 230, 1);
			border-radius: .18rem;
			font-weight: 500;
			font-size: .12rem;
			color: #FFFFFF;
			cursor: pointer;
		}

		/* 左右箭头 */
		.arrow {
			width: .4rem;
			height: .4rem;
			line-height: .4rem;
			text-align: center;
			color: rgba(185, 185, 187, 1);
			font-weight: 700;
			font-size: .32rem;
			cursor: pointer;
			user-select: none;
		}

		.arrow.left {
			margin-right: .1rem;
		}

		.arrow.right {
			margin-left: .1rem;
		}
	}
</style>